<template>
  <LoadingScreen id="loading-screen" />
  <Navbar />
  <div class="page-content" :style="cssProps">
    <!-- <h1>
      Meet &
      {{ and.charAt(0).toUpperCase() + and.slice(1) }}
    </h1> -->
    <h1>Date</h1>
    <h3>
      Find other people and arrange a meet for you and your pets to play
      together, or talk to someone to learn the perks of having a pet!
    </h3>
    <div class="availability-check">
      <label for="availability">Are you available?</label>
      <div class="select">
        <select
          name="availability"
          id="availability-selector"
          v-model="userData.available"
          @change="changeStatus()"
        >
          <option value="true">Yes, please!</option>
          <option value="false">Not yet!</option>
        </select>
      </div>
    </div>
    <div
      class="distance-picker"
      :style="status.toString() == 'true' ? 'displa: flex;' : 'display: none;'"
    >
      <label for="distance">Dinstance ({{ distance }}km): </label>
      <input
        type="range"
        min="1"
        max="15"
        v-model="distance"
        name="distance"
        id="dinstance-slider"
        @change="fetchAvailableMounted(true)"
      />
      <CircularButton
        icon="sync-alt"
        color="var(--light-clr)"
        @click="fetchAvailableMounted"
      />
    </div>
    <!-- <div class="category-check">
      <label for="category">Pick category</label>
      <div class="select">
        <select
          name="category"
          id="category-selector"
          v-model="userData.category"
        >
          <option selected="selected" value="all">All</option>
          <option value="play">Date2play</option>
          <option value="learn" disabled>Date2learn</option>
        </select>
      </div>
    </div> -->
    <div class="category-check">
      <input
        type="radio"
        id="date2play"
        value="play"
        v-model="userData.category"
      />
      <label for="date2play">Date2play</label>
      <input
        type="radio"
        id="date2learn"
        value="learn"
        v-model="userData.category"
        disabled
      />
      <label for="date2learn">Date2learn</label>
    </div>
    <div
      class="available-users"
      :style="status.toString() == 'true' ? 'displa: flex;' : 'display: none;'"
    >
      <h2>Available Pet Owners</h2>
      <div id="avail-user-container"></div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import CircularButton from "@/components/CircularButton.vue";
import axios from "axios";
import Swal from "sweetalert2";
import LoadingScreen from "@/components/LoadingScreen.vue";

let headers = {};
let _self;

const Toast = Swal.mixin({
  toast: true,
  position: "bottom-right",
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

function setStatusClr(self) {
  // console.log(self.userData.available);
  if (self.userData.available.toString() == "true") {
    self.statusClr = "var(--success)";
  } else {
    self.statusClr = "var(--danger)";
  }
  // console.log(self.statusClr);
}

function validURL(str) {
  var pattern =
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
  return pattern.test(str);
}

function fetchAvailable(update) {
  let userContainer = document.querySelector("#avail-user-container");
  axios
    .get(`${process.env.VUE_APP_BACKEND}/walk/available/${_self.distance}`, {
      headers: headers,
    })
    .then(function (res) {
      if (update) {
        let data = {
          distance: _self.distance,
        };
        axios
          .put(`${process.env.VUE_APP_BACKEND}/users/update`, data, {
            headers: headers,
          })
          // .then(function () {})
          .catch(function (err) {
            Toast.fire({
              icon: "error",
              title: "Couldn't update the distance.",
              text: `${err}`,
            });
          });
      }
      if (res.data.length == 0) {
        Toast.fire({
          icon: "error",
          title:
            "Sorry... There are no available users near you at the moment.",
        });
      } else {
        userContainer.innerHTML = "";

        res.data.forEach((element) => {
          // console.log(element);
          let newElement = document.createElement("a");
          let imgContainer = document.createElement("div");
          imgContainer.classList.add("avail-user-img-cont");
          let imgElement = document.createElement("img");
          imgElement.classList.add("avail-user-img");
          imgContainer.appendChild(imgElement);
          let imgLink = "";
          newElement.setAttribute("href", "/user_info?email=" + element.email);

          let elementText = document.createElement("p");
          elementText.innerHTML = element.firstName + " " + element.lastName;

          newElement.classList.add("avail-user");
          // newElement.appendChild()
          userContainer.appendChild(newElement);

          if (validURL(element.profileImage)) {
            imgLink = element.profileImage;
            imgElement.setAttribute("src", imgLink);
          } else {
            axios
              .get(
                `${process.env.VUE_APP_BACKEND}/users/images/${element.profileImage}`,
                {
                  headers: headers,
                }
              )
              .then(function () {
                imgLink = `${process.env.VUE_APP_BACKEND}/users/images/${element.profileImage}`;
                // console.log(imageRes);
                imgElement.setAttribute("src", imgLink);
              })
              .catch(() => {
                imgLink = "/paw.svg";
                imgElement.setAttribute("src", imgLink);
              });
          }
          // console.log("Link: ", imgLink);
          // imgElement.setAttribute("src", imgLink);
          newElement.appendChild(imgContainer);
          newElement.appendChild(elementText);
        });
      }
    })
    .catch((err) => {
      console.error(err);
    });
}

export default {
  name: "Date",
  components: {
    Navbar,
    CircularButton,
    LoadingScreen,
  },
  mounted() {
    let self = this;

    let title = "Date - Dating4Pets";

    // const query = window.location.search;
    // const getParameters = new URLSearchParams(query);

    // if (getParameters.has("signup")) {
    // if (getParameters.get("and")) {
    //   self.and = getParameters.get("and");
    //   document.title = `Meet & ${
    //     self.and.charAt(0).toUpperCase() + self.and.slice(1)
    //   } - Dating4Pets`;
    // } else {
    document.title = title;
    // }
    _self = this;
    // toggleContentVisibility();
    let jwt = localStorage.getItem("jwt");

    if (jwt == null) {
      self.$router.push("/");
    }

    headers = {
      Authorization: "Bearer " + jwt,
    };

    axios
      .get(`${process.env.VUE_APP_BACKEND}/users/info`, {
        headers: headers,
      })
      .then(function (res) {
        // console.log(res);
        self.userData.firstName = res.data.firstName;
        self.userData.lastName = res.data.lastName;
        self.userData.email = res.data.email;
        self.userData.age = res.data.age;
        self.userData.available = res.data.available;
        self.userData.lon = res.data.lon;
        self.userData.lat = res.data.lat;
        self.distance = res.data.distance;

        if (!self.userData.available) {
          self.userData.available = false;
        }
        setStatusClr(self);
        if (self.userData.available) {
          fetchAvailable();
        }
        self.status = self.userData.available;

        // let loadingScreen = document.querySelector("#loading-screen");
        // loadingScreen.classList.add("fade-out");

        setTimeout(() => {
          let loadingScreen = document.querySelector("#loading-screen");
          loadingScreen.classList.add("fade-out");
        }, 1000);

        // SET AVAILABILITY FOR WALK
        // IF AVAILABLE => ASK FOR LOCATION
      })
      .catch((err) => {
        // console.log(err.response.data.statusCode);
        setTimeout(() => {
          let loadingScreen = document.querySelector("#loading-screen");
          loadingScreen.classList.add("fade-out");
        }, 1000);
        if (err.response) {
          if (err.response.data.statusCode == 401) {
            localStorage.removeItem("jwt");
            self.$router.push("/");
          } else {
            Swal.fire("Error", `${err}`, "error");
          }
        } else {
          Swal.fire("Error", `${err}`, "error");
        }
      });
  },
  data() {
    return {
      userData: {
        firstName: "",
        lastName: "",
        email: "",
        age: "",
        available: false,
        category: "all",
        lon: "",
        lat: "",
      },
      availableUsers: {},
      statusClr: "var(--danger)",
      status: "false",
      distance: 1,
      and: "walk",
    };
  },
  computed: {
    cssProps() {
      return {
        "--selection": this.statusClr,
      };
    },
  },
  methods: {
    changeStatus() {
      let self = this;

      setStatusClr(self);
      let data = { available: this.userData.available == "true" };
      // console.log(headers);

      if (data.available) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            function success(res) {
              // console.log(res);
              // console.log(self.userData.lon, self.userData.lat);
              self.userData.lon = res.coords.longitude;
              self.userData.lat = res.coords.latitude;
              // console.log(self.userData.lon, self.userData.lat);
              data["lon"] = Number.parseFloat(self.userData.lon).toFixed(6);
              data["lat"] = Number.parseFloat(self.userData.lat).toFixed(6);

              // console.log(headers);

              const dummyData = {};
              axios
                .post(`${process.env.VUE_APP_BACKEND}/walk/ready`, dummyData, {
                  headers: headers,
                })
                .then(function () {
                  headers["content-type"] = "application/json";
                  axios
                    .put(`${process.env.VUE_APP_BACKEND}/users/update`, data, {
                      headers: headers,
                    })
                    .then(function () {
                      Toast.fire({
                        icon: "success",
                        title: "Your availability has changed.",
                      });
                      self.status = self.userData.available;
                      self.$router.go();
                    })
                    .catch(function () {
                      Toast.fire({
                        icon: "error",
                        title:
                          "Sorry... There are no available users near you at the moment.",
                      });
                    });
                })
                .catch(function (err) {
                  Toast.fire({
                    icon: "error",
                    title: "There was an error updating your location.",
                    text: err,
                  }).then(() => {
                    self.$router.go();
                  });
                });
            },
            function failure(err) {
              // console.log("Error: ", err);
              Toast.fire({
                icon: "error",
                title:
                  "Sorry... There was an error while trying to get your position. Error: " +
                  err.message,
              }).then(() => {
                return;
              });
            }
          );
        } else {
          Toast.fire({
            icon: "error",
            title: "Sorry... Geolocation is not supported by your browser.",
          }).then(() => {
            return;
          });
        }
      } else {
        headers["content-type"] = "application/json";
        // console.log(data);
        // const dummyData = {};

        axios
          .delete(`${process.env.VUE_APP_BACKEND}/walk/stop`, {
            headers: headers,
          })
          .then(function () {
            headers["content-type"] = "application/json";

            axios
              .put(`${process.env.VUE_APP_BACKEND}/users/update`, data, {
                headers: headers,
              })
              .then(function () {
                const userContainer =
                  document.querySelector(".available-users");
                userContainer.innerHTML = "";
                Toast.fire({
                  icon: "success",
                  title: "Your availability has changed.",
                });
                self.status = self.userData.available;
                self.$router.go();
              })
              .catch(function (err) {
                Toast.fire({
                  icon: "error",
                  title: "An error occurred.",
                  text: `${err}`,
                });
              });
          })
          .catch(function () {});
      }
    },
    fetchAvailableMounted(update) {
      fetchAvailable(update);
    },
  },
  watch: {
    $route() {
      let self = this;
      const query = window.location.search;
      const getParameters = new URLSearchParams(query);

      if (getParameters.get("and")) {
        self.and = getParameters.get("and");
      }
    },
  },
};
</script>

<style scoped>
.select::before {
  content: "";
  height: 0.5em;
  aspect-ratio: 1;
  top: calc(50% - 0.25em);
  right: 1em;
  background: var(--selection);
  position: absolute;
  border-radius: 100%;
  box-shadow: var(--light-box-shadow);
  z-index: 3;
  transition: var(--transition);
  opacity: 1;
}

.distance-picker {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: var(--gap);
  overflow: visible;
  background: var(--light-clr);
  box-shadow: var(--light-box-shadow);
  padding: 1em;
  border-radius: 1000em;
  min-width: 15em;
  width: 100%;
  max-width: 35em;
}

.distance-picker label {
  white-space: nowrap;
  width: 100%;
}

input[type="range"] {
  /* border: none; */
  appearance: none;
  height: 1em;
  margin-block: 1em;
  min-width: 15em;
  width: 70%;
  max-width: 20em;
  background: white;
  color: var(--dark-clr);
  border-radius: 2rem;
  padding: 0.2rem 1rem;
  margin: 0.2rem;
  /* margin-inline-start: auto; */
  border: none;
  box-shadow: var(--box-shadow);
  font-weight: bold;
  transition: 0.5s ease;
}

input[type="range"]::-webkit-slider-thumb,
input[type="range"]::-moz-range-thumb {
  appearance: none;
  cursor: pointer;
  background: var(--dark-clr);
  border: none;
  height: 1em;
  aspect-ratio: 1;
}

@media screen and (max-width: 30rem) {
  h2 {
    font-size: 1.2em;
  }
}

@media screen and (max-width: 40rem) {
  .availability-check,
  .category-check {
    flex-direction: column;
  }
}
@media screen and (max-width: 40rem) {
  .distance-picker {
    flex-direction: column;
  }
}

.invisible {
  display: none;
}

.category-check input[type="radio"] {
  opacity: 0;
}

.category-check label {
  cursor: pointer;
  background: white;
  padding-block: 0.5em;
  padding-inline: 1em;
  border-radius: 1000em;
  transition: var(--transition);
}

.category-check label:hover,
.category-check label:focus {
  box-shadow: var(--box-shadow-focus);
}

.category-check input[type="radio"]:checked + label {
  background: var(--success);
  color: white;
}

.category-check input:disabled + label {
  background: grey;
  color: white;
  cursor: not-allowed;
}
</style>
